import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { clubApi } from "../../../club-api-client";
import { queryKeys } from "../../query-keys";

export function useClubCourts(clubId: string | undefined, locationId: string | undefined) {
	return useQuery({
		queryKey: queryKeys.clubPortal.clubCourts(clubId ?? "", locationId ?? ""),
		queryFn: () => clubApi.clubCourts.list(clubId as string, locationId as string),
		enabled: !!clubId && !!locationId,
	});
}

export function useCreateClubCourt(clubId: string, locationId: string) {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: (data: { name: string; sort_order?: number }) =>
			clubApi.clubCourts.create(clubId, locationId, data),
		onSuccess: () => {
			qc.invalidateQueries({
				queryKey: queryKeys.clubPortal.clubCourts(clubId, locationId),
			});
		},
	});
}

export function useUpdateClubCourt(clubId: string, locationId: string) {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: ({
			courtId,
			data,
		}: {
			courtId: string;
			data: { name?: string; sort_order?: number };
		}) => clubApi.clubCourts.update(clubId, locationId, courtId, data),
		onSuccess: () => {
			qc.invalidateQueries({
				queryKey: queryKeys.clubPortal.clubCourts(clubId, locationId),
			});
		},
	});
}

export function useDeleteClubCourt(clubId: string, locationId: string) {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: (courtId: string) => clubApi.clubCourts.delete(clubId, locationId, courtId),
		onSuccess: () => {
			qc.invalidateQueries({
				queryKey: queryKeys.clubPortal.clubCourts(clubId, locationId),
			});
		},
	});
}
